export default "__VITE_ASSET__DBsyt8_1__"